"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib"); // @ts-nocheck


var getComputedStyle_1 = tslib_1.__importDefault(require("./getComputedStyle"));
/**
 * @param element
 */


function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle_1$d = getComputedStyle_1["default"](element),
      overflow = _getComputedStyle_1$d.overflow,
      overflowX = _getComputedStyle_1$d.overflowX,
      overflowY = _getComputedStyle_1$d.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

exports["default"] = isScrollParent;